import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { Rental } from '@tokeet/tv3-platform'

@Component({
  selector: 'app-edit-fees-dialog',
  host: { class: 'modal-content' },
  templateUrl: './booking-fees-dialog.component.html',
  styleUrls: ['./booking-fees-dialog.component.scss'],
})
export class BookingFeesDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<BookingFeesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { rental: Rental }
  ) {}

  onClose() {
    this.dialogRef.close()
  }
}
